import React, { Component } from "react";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import TextInput from "../../../components/inputs/TextInput";
import RadioButton from "../../../components/membership/membershipTaskList/RadioButton";
import DatePicker from "../../../components/datePicker/DatePicker";
import ImageCropperWithUpload from "../../../components/ImageUpload/UploadImage";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { checkParameters, encryptAES } from "../../../utils/Encryption";
import DateInput from "../../../components/inputs/DateInput";
import CPASMemberServices from "../../../services/axiosServices/apiServices/CPASMemberServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import moment from "moment";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import { saveAs } from "file-saver";
import { CPASScoringSheetValidationRules } from "./CpasMemberValidationRules";
import { isValidForm, validate } from "../../../utils/validation/CommonValidator";
import ValidationText from "../../../utils/validation/ValidationText";
import { CommonSuccessMessages } from "../../../utils/Messages";
import { Navigate } from "react-router-dom";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";

export default class PreAssessorCpasScoringSheet extends Component {
    constructor(props) {
        super(props);

        this.CPASMemberServices = new CPASMemberServices();
        this.swalServices = new SwalServices();

        this.state = {
            isLoading: false,
            redirect: null,
            isDraftLoading: false,
            inputValue: "",
            PassorFail: "",
            croppedImage: null,
            updatedBy: 0,
            updatedAppId: 0,
            adminName: "",
            isWrittenLoader: false,
            successMessage: "",
            cpasMemberid: 0,
            scoringSheetDetails: {
                scoringSheetId: 0,
                cpasMemberId: 0,
                applicationTierId: 0,
                mrMrsId: 0, // Nullable
                firstName: "", // Nullable
                lastName: "",
                statusId: 0,
                candidateName: "",
                preAssessmentScore: null,
                //  finalScore: 0,
                comment: "",
                assessorName: "",
                dateofAssessment: "",
                filePath: "",
                email: ""
            },
            validStateScoringSheet: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        const audit = getAuditContext()

        let params = new URLSearchParams(window.location.search);
        let cpasId = params.get("");

        if (cpasId && (cpasId = checkParameters(cpasId, "Number"))) {
            if (cpasId > 0) {
                this.setState({ cpasMemberid: cpasId }, () => {
                    // NOW state is guaranteed ready
                    this.GetCPASScoringSheetDetailById(cpasId);
                });
            }
        }
        this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });
    }


    GetCPASScoringSheetDetailById = (id) => {
        this.CPASMemberServices.GetCPASScoringSheetDetailById(id).then(
            (response) => {
                if (response.statusCode === 200 && response.responseItem != null) {

                    if (response.responseItem.responseContent != null) {

                        let content = response.responseItem.responseContent;
                        let res = { ...this.state.scoringSheetDetails };
                        res.scoringSheetId = content.scoringSheetId;
                        res.cpasMemberId = content.cpasMemberId;
                        res.mrMrsId = content.mrMrsId;
                        res.firstName = content.firstName || "";
                        res.lastName = content.lastName || "";
                        res.filePath = content.scoringReportFilePath;
                        res.dateofAssessment = content.dateOfAssessment;
                        res.assessorName = content.assessorName;
                        res.comment = content.comment;
                        res.preAssessmentScore = content.preAssessmentScore;
                        res.email = content.email;
                        res.statusId = content.statusId;
                        // Combine First Name and Last Name for the Candidate Name field
                        res.candidateName = `${res.firstName} ${res.lastName}`.trim();

                        this.setState({ scoringSheetDetails: res });
                    }
                } else {
                    this.swalServices.Error(response.message);
                }
            }
        );
    };



    onFileChange = (event, identity) => {
        const file = event.target.files[0];
        if (file.size < 5242880) {
            if (identity === "Score_Sheet") {
                if (
                    file &&
                    (
                        file.type === "application/vnd.ms-excel" || // .xls
                        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
                    )
                ) {

                    let uploadFile = { ...this.state.resFile };
                    uploadFile.filename = file.name;
                    uploadFile["file"] = file;
                    uploadFile.storagePath =
                        "CPASMemberData\\CPASScoringWrittenReports";
                    this.setState({ isUploadAccreditedConstruction: true });
                    this.CPASMemberServices.uploadPDF(uploadFile).then((response) => {
                        if (response != null) {
                            if (response.isNotCurrupted == true) {
                                let detail = this.state.scoringSheetDetails;
                                detail.filePath = response.fileName;
                                this.swalServices.Success("File Uploaded");
                                this.setState({ scoringSheetDetails: detail }, () => {
                                    // this.validateField("accreditedConProReportPath", "Education_Information")
                                });
                            } else {
                                this.swalServices.Error("Invalid Document");
                            }
                        } else {
                            this.swalServices.Error(response.message);
                        }
                        this.setState({ isUploadAccreditedConstruction: false });
                    });
                } else {
                    this.swalServices.Error("Please upload only Excel files (.xls, .xlsx)");
                }
            }
        } else {
            this.swalServices.Error("File size must be less than 5 MB");
        }
    };
    handleScoringChange = (e) => {
        const { name, value } = e.target;

        // Validate Pre-Assessment Score
        if (name === "preAssessmentScore") {
            if (!/^\d*\.?\d*$/.test(value)) {
                this.setState((prevState) => ({
                    validStateScoringSheet: {
                        ...prevState.validStateScoringSheet,
                        error: {
                            ...prevState.validStateScoringSheet.error,
                            preAssessmentScore: "Only integer or decimal values are allowed."
                        }
                    }
                }));
                return;
            }

            // Clear validation message for valid input
            this.setState((prevState) => ({
                validStateScoringSheet: {
                    ...prevState.validStateScoringSheet,
                    error: {
                        ...prevState.validStateScoringSheet.error,
                        preAssessmentScore: ""
                    }
                }
            }));
        }

        this.setState((prevState) => ({
            scoringSheetDetails: {
                ...prevState.scoringSheetDetails,
                [name]: value.toUpperCase(),
            },
        }));
    };

    handleInputChange = (event) => {
        this.setState({ inputValue: event.target.value });
    };

    handleRadioButtons = (event) => {
        this.setState({ PassorFail: event.target.value });
    };

    handleSaveImage = (event, file, keyId, imageIdentity, index) => {
        console.log("Saved Image Data:", file);
        this.setState({ croppedImage: file.fileStr });
    };

    UpdateSecretariatAndPreAssessmentStatus = (statusId) => {
        const audit = getAuditContext()

        const req = {
            cpasMemberId: this.state.cpasMemberid,
            statusId: statusId,
            updatedBy: audit.adminUserId,
            updatedAppId: audit.appId


        };

        this.CPASMemberServices.UpdateSecretariatAndPreAssessmentStatus(req).then(
            (response) => {
                if (response.statusCode === 200) {
                    this.setState({
                        secretariatAndPreAssessmentStatusId: statusId,
                        isLoading: false
                    });

                    if (statusId === 31) {
                        this.swalServices.Success("Saved as Draft successfully");
                    }

                    if (statusId === 34) {
                        this.swalServices.Success("Assessment Approved Successfully");
                        this.GetCPASScoringSheetDetailById(this.state.cpasMemberid);

                    }
                } else {
                    this.swalServices.Error(response.message);
                    this.setState({ isLoading: false });
                }
            }
        );
    };
    isValidateAllFields = (section) => {
        if (section === "CPASScoringSheet") {

            const newValidState = isValidForm(

                this.state.scoringSheetDetails,
                CPASScoringSheetValidationRules,
                this.state.validStateScoringSheet
            );
            this.setState({ validStateScoringSheet: newValidState });
            return newValidState.isValid;
        }
    };
    validateField = (key, section) => {

        if (section === "CPASScoringSheet") {
            const newValidState = validate(
                key,
                this.state.scoringSheetDetails,
                CPASScoringSheetValidationRules,
                this.state.validStateScoringSheet
            );
            this.setState({ validStateScoringSheet: newValidState });
        }
    }
    AddEditCPASScoringSheet = (statusId) => {

        const audit = getAuditContext()
        const score = String(this.state.scoringSheetDetails.preAssessmentScore ?? "").trim();

        if (!/^\d+(\.\d+)?$/.test(score)) {
            this.swalServices.Warning(
                "Please enter a valid Pre-Assessment Score. Only integer or decimal values are allowed."
            );
            return;
        }

        const isValid = this.isValidateAllFields("CPASScoringSheet");
        if (isValid) {
            this.swalServices
                .Confirm(
                    CommonSuccessMessages.Confirm_CPASScoring_Information.replace(
                        "{0}",
                        "Admin"
                    ),
                    "",
                    CommonSuccessMessages.Yes_Text,
                    CommonSuccessMessages.No_Text
                ).then((response) => {
                    if (!response) return;
                    this.setState({ isLoading: true });
                    const details = this.state.scoringSheetDetails;
                    const req = {
                        scoringSheetId: details.scoringSheetId || null, // if editing
                        cpasMemberId: details.cpasMemberId,
                        candidateName: details.candidateName,
                        preAssessmentScore: details.preAssessmentScore,
                        // finalScore: details.finalScore,
                        comment: details.comment,
                        assessorName: details.assessorName,
                        dateOfAssessment: details.dateofAssessment,
                        scoringReportFilePath: details.filePath,
                        updatedBy: audit.adminUserId,
                        updatedAppId: audit.appId,
                        email: details.email,
                        statusId: statusId
                    };
                    this.CPASMemberServices.AddEditCPASScoringSheet(req).then(
                        (response) => {
                            if (response.statusCode === 200) {
                                this.UpdateSecretariatAndPreAssessmentStatus(statusId);
                            } else {
                                this.swalServices.Error(response.message);
                                this.setState({ isLoading: false });
                            }
                            this.setState({ isLoading: false });
                        }
                    );

                });
        }
        else {
            this.swalServices.Warning("Please fill Scoring Sheet");
        }

    };



    onSubmitScoringSheet = (statusId) => {
        const audit = getAuditContext()

        this.setState({ isDraftLoading: true });
        const details = this.state.scoringSheetDetails;
        const req = {
            scoringSheetId: details.scoringSheetId || null, // if editing
            cpasMemberId: details.cpasMemberId,
            candidateName: details.candidateName,
            preAssessmentScore: details.preAssessmentScore,
            // finalScore: details.finalScore,
            comment: details.comment,
            assessorName: details.assessorName,
            dateOfAssessment: details.dateofAssessment,
            scoringReportFilePath: details.filePath,
            updatedBy: audit.adminUserId,
            updatedAppId: audit.appId,
            email: details.email,
            statusId: statusId
        };
        this.CPASMemberServices.AddEditCPASScoringSheet(req).then(
            (response) => {
                if (response.statusCode === 200) {
                    this.UpdateSecretariatAndPreAssessmentStatus(statusId);
                    this.GetCPASScoringSheetDetailById(this.state.scoringSheetDetails.cpasMemberId);
                } else {
                    this.swalServices.Error(response.message);
                    this.setState({ isDraftLoading: false });
                }
                this.setState({ isDraftLoading: false });
            }
        );
    };



    GetCPASMemberFiles = (type, Filepath) => {
        let request = [this.state.cpasMemberid, type, Filepath];

        this.CPASMemberServices.GetCPASMemberFiles(request).then((response) => {
            if (response.data !== null && response.status === 200) {
                let formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
                let filename = "";
                filename = `${type}${formattedDate}`;
                const extension = Filepath.split(".").pop();
                let file = "";
                if (extension == "pdf") {
                    file = new Blob([response.data], { type: "application/pdf" });
                    URL.createObjectURL(file);
                    window.open(URL.createObjectURL(file), "_blank");
                    saveAs(file, `${filename}.${extension}`);
                } else {
                    file = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    URL.createObjectURL(file);
                    saveAs(file, `${filename}.${extension}`);
                }
            } else {
                this.swalServices.Error(response.message);
            }

        });
    };



    render() {
        const { croppedImage } = this.state;

        const isDisabled = this.state.scoringSheetDetails.statusId !== 31;
        const isCandidateDisabled = this.state.scoringSheetDetails.statusId === 31;

        if (this.state.redirect != null) {
            return <Navigate to={this.state.redirect} />;
        }

        return (
            <>
                <div className="main-body-section">
                    <div className="bg-white border border-[#c9c9c9] mb-3">
                        <div className="tab w-full border-t">
                            <input className="absolute opacity-0 toggle-main" />

                            <label className="heading-part px-7 py-4 border-b border-[#c9c9c9] flex items-center justify-between relative w-auto leading-normal cursor-pointer">
                                <span className="small-title font-bold theme-color">
                                    CPAS Scoring Sheet
                                </span>
                            </label>

                            <div className="committee-info-overflow leading-normal px-0">
                                <div className="w-full organisation-basic-information">

                                    {/* 🔹 Disabled Wrapper Added Here */}
                                    <div
                                        className={`2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5 }
                                        `}
                                    >

                                        <div className="grid grid-cols-12 gap-x-12 gap-y-4 w-full justify-between mt-3 mb-3">

                                            {/* Candidate Name */}
                                            <div className="lg:col-span-6 col-span-12 ">
                                                <label className="font-semibold mb-2 block">
                                                    Candidate Name <span className="text-red-500">*</span>
                                                </label>

                                                <TextInput
                                                    className={`form-input w-full ${isCandidateDisabled || isDisabled ? "bg-gray-100 cursor-not-allowed opacity-70" : ""
                                                        }`}
                                                    placeholder="Candidate Name"
                                                    name="candidateName"
                                                    value={this.state.scoringSheetDetails.candidateName}
                                                    identity="Caps_Application"
                                                    handleChange={this.handleScoringChange}
                                                    disabled={isCandidateDisabled || isDisabled}

                                                    onBlur={() =>
                                                        this.validateField("candidateName", "CPASScoringSheet")
                                                    }
                                                />

                                                <ValidationText
                                                    error={this.state.validStateScoringSheet.error.candidateName}
                                                />
                                            </div>

                                            {/* Pre Assessment */}
                                            <div className="lg:col-span-6 col-span-12 field-customize">
                                                <label className="font-semibold mb-2 block">
                                                    Pre-Assessment Score <span className="text-red-500">*</span>
                                                </label>

                                                <div className="dropdown">
                                                    <TextInput
                                                        className={`form-input w-full ${isDisabled ? "bg-gray-100 cursor-not-allowed opacity-70" : ""
                                                            }`}
                                                        placeholder=""
                                                        name="preAssessmentScore"
                                                        value={this.state.scoringSheetDetails.preAssessmentScore}
                                                        identity="Caps_Application"
                                                        handleChange={this.handleScoringChange}
                                                        disabled={isDisabled}
                                                        onBlur={() =>
                                                            this.validateField("preAssessmentScore", "CPASScoringSheet")
                                                        }
                                                    />

                                                    <ValidationText
                                                        error={this.state.validStateScoringSheet.error.preAssessmentScore}
                                                    />
                                                </div>
                                            </div>

                                            {/* Application Number */}
                                            {/* Assessor Name */}
                                            <div className="lg:col-span-6 col-span-12">
                                                <label className="font-semibold mb-2 block">
                                                    Assessor Name <span className="text-red-500">*</span>
                                                </label>

                                                <div className="dropdown">
                                                    <TextInput
                                                        className={`form-input w-full ${isDisabled ? "bg-gray-100 cursor-not-allowed opacity-70" : ""
                                                            }`}
                                                        placeholder=""
                                                        name="assessorName"
                                                        value={this.state.scoringSheetDetails.assessorName}
                                                        identity="Caps_Application"
                                                        handleChange={this.handleScoringChange}
                                                        disabled={isDisabled}
                                                        onBlur={() =>
                                                            this.validateField("assessorName", "CPASScoringSheet")
                                                        }
                                                    />

                                                    <ValidationText
                                                        error={this.state.validStateScoringSheet.error.assessorName}
                                                    />
                                                </div>
                                            </div>

                                            {/* Date */}
                                            <div className="lg:col-span-6 col-span-12">
                                                <label className="font-semibold mb-2 block">
                                                    Date of Assessment <span className="text-red-500">*</span>
                                                </label>

                                                <DateInput
                                                    className={`form-input w-full ${isDisabled ? "bg-gray-100 cursor-not-allowed opacity-70" : ""
                                                        }`}
                                                    name="dateofAssessment"
                                                    value={
                                                        this.state.scoringSheetDetails.dateofAssessment
                                                            ? moment(
                                                                this.state.scoringSheetDetails.dateofAssessment
                                                            ).format("YYYY-MM-DD")
                                                            : ""
                                                    }
                                                    identity="Caps_Application"
                                                    handleChange={this.handleScoringChange}
                                                    disabled={isDisabled}
                                                    onBlur={() =>
                                                        this.validateField("dateofAssessment", "CPASScoringSheet")
                                                    }
                                                />

                                                <ValidationText
                                                    error={this.state.validStateScoringSheet.error.dateofAssessment}
                                                />
                                            </div>

                                        </div>

                                        {/* Comment */}
                                        <div className="pl-0 lg:col-span-12 col-span-12">
                                            <label className="font-semibold mb-2 block">
                                                Comment <span className="text-red-500">*</span>
                                            </label>

                                            <div className="dropdown">
                                                <textarea
                                                    className={`form-input w-full ${isDisabled ? "bg-gray-100 cursor-not-allowed opacity-70 w-45" : "w-45"
                                                        }`}
                                                    placeholder=""

                                                    name="comment"
                                                    value={this.state.scoringSheetDetails.comment}
                                                    identity="Caps_Application"
                                                    onChange={this.handleScoringChange}

                                                    disabled={isDisabled}
                                                    onBlur={() =>
                                                        this.validateField("comment", "CPASScoringSheet")
                                                    }
                                                />

                                                <ValidationText
                                                    error={this.state.validStateScoringSheet.error.comment}
                                                />
                                            </div>
                                        </div>

                                        {/* Upload Section */}
                                        <div className="form-info-title">
                                            <h3 className="text-lg font-bold mb-1"> Upload Score Sheet </h3>

                                            <div className="flex items-center justify-between mb-1">
                                                <button
                                                    type="button"
                                                    className="underline text-[#005b9c] font-[500] pl-4"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.GetCPASMemberFiles(
                                                            "Templates",
                                                            "Pre-Assessment Scoresheet.xlsx"
                                                        );
                                                    }}
                                                >
                                                    Download template
                                                </button>

                                            </div>

                                            <div className="dropdown">
                                                <div className="select-dropdown w-full">

                                                    {this.state.isWrittenLoader ? (
                                                        <ButtonLoader type="btn btn-caps" />
                                                    ) : (

                                                        <form className="custom-uploader custom-file-upload-btn flex items-center gap-4">
                                                            <div
                                                                className={`border rounded-lg p-4 flex items-center gap-4`}
                                                            >
                                                                <label
                                                                    htmlFor="Score_Sheet"
                                                                    className={`btn btn-caps text-white 
                                                                     ${isDisabled ? "bg-gray-400 cursor-not-allowed pointer-events-none" : "cursor-pointer"}`}
                                                                >
                                                                    Upload File
                                                                </label>

                                                                <input
                                                                    className="sr-only"
                                                                    id="Score_Sheet"
                                                                    type="file"
                                                                    accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                                    disabled={isDisabled}
                                                                    onChange={(event) =>
                                                                        this.onFileChange(event, "Score_Sheet")
                                                                    }
                                                                />

                                                                {this.state.scoringSheetDetails.filePath && (
                                                                    <button
                                                                        type="button"
                                                                        className="underline text-[#005b9c] font-[500]"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            this.GetCPASMemberFiles(
                                                                                "Score_Sheet",
                                                                                this.state.scoringSheetDetails.filePath
                                                                            );
                                                                        }}
                                                                    >
                                                                        <span className="text-xl text-[#4687C6] font-semibold tracking-normal underline">
                                                                            View Files
                                                                        </span>
                                                                    </button>
                                                                )}

                                                                <span className={`text-sm ${isDisabled ? "text-gray-400" : "text-gray-500"}`}>
                                                                    XLS / XLSX only
                                                                </span>

                                                            </div>
                                                        </form>
                                                    )}

                                                    {this.state?.scoringSheetDetails?.filePath && (
                                                        <div className="mt-5 file-uploaded-txt flex items-center">
                                                            <img
                                                                src="/check-caps.png"
                                                                className="w-[25px] mr-3"
                                                                alt=""
                                                            />

                                                            <span className="text-[#000]">
                                                                {this.state.scoringSheetDetails.filePath}
                                                            </span>
                                                        </div>
                                                    )}

                                                    <ValidationText
                                                        error={this.state.validStateScoringSheet.error.filePath}
                                                    />

                                                </div>
                                            </div>
                                        </div>

                                        {/* Buttons */}
                                        <div className="flex justify-between mt-10 preassessor-buttons">

                                            {/* Left side: Save as Draft + Back */}
                                            <div className="flex flex-col gap-3">
                                                {this.state.isDraftLoading ? (
                                                    <ButtonLoader />
                                                ) : (
                                                    <button
                                                        className="btn btn-blue-border text-white"
                                                        disabled={isDisabled}
                                                        onClick={() => this.onSubmitScoringSheet(31)}
                                                    >
                                                        Save as Draft
                                                    </button>
                                                )}

                                                <button
                                                    className="w-32 px-7 py-2 btn-sm bg-black text-white text-lg hover:bg-black"
                                                    onClick={() => {
                                                        const encryptedId = encryptAES(this.state.cpasMemberid);
                                                        this.setState({
                                                            redirect: `/ViewCPASApplication/CPASMemberId?=${encryptedId}`,
                                                        });
                                                    }}
                                                >
                                                    Back
                                                </button>
                                            </div>

                                            {/* Right side: Approve */}
                                            <div>
                                                {this.state.isLoading ? (
                                                    <ButtonLoader />
                                                ) : (
                                                    <button
                                                        className="btn btn-sen-pre-assessment"
                                                        disabled={isDisabled}
                                                        onClick={() => this.AddEditCPASScoringSheet(34)}
                                                    >
                                                        Approve
                                                    </button>
                                                )}
                                            </div>


                                        </div>

                                    </div>
                                    {/* 🔹 Wrapper Ends Here */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }


}
